import { all, fork } from 'redux-saga/effects';
import profileSaga from './components/Profile/profileSaga';
import registerSaga from './components/Register/registerSaga';
import loginSaga from './components/Login/loginSaga';
import dashboardSaga from './components/Dashboard/dashboardSaga';
import findUsersSaga from './components/FindUsers/findUsersSaga';
import moviesSaga from './components/Movies/moviesSaga';

function* rootSaga() {
    yield all([
        fork(profileSaga),
        fork(registerSaga),
        fork(loginSaga),
        fork(dashboardSaga),
        fork(findUsersSaga),
        fork(moviesSaga),
    ]);
}

export default rootSaga;
